<template>
  <article class="detail-person">
    <div class="person-photo">
      <button v-if="assignment.photo && !photoFailed && interactive" type="button" class="person-photo-button" :aria-label="$t('building.plan.enlargePhoto', { name: assignment.name })" @click="$emit('photo', assignment)">
        <v-img :src="photoUrl(endpoint, assignment.photo)" :alt="assignment.name" width="52" height="64" @error="photoFailed = true" />
        <v-icon small class="photo-enlarge" aria-hidden="true">mdi-magnify-plus-outline</v-icon>
      </button>
      <img v-else-if="assignment.photo && !photoFailed" class="person-thumbnail" :src="photoUrl(endpoint, assignment.photo)" :alt="assignment.name" width="52" height="64" loading="eager" @error="photoFailed = true" />
      <v-icon v-else>mdi-account</v-icon>
      <v-tooltip v-if="assignment.temporaryPhoto && interactive" bottom>
        <template v-slot:activator="{ on, attrs }"><v-icon small class="photo-temporary" v-bind="attrs" v-on="on">mdi-clock-outline</v-icon></template>
        {{ $t('building.plan.temporaryPhoto') }}
      </v-tooltip>
      <v-icon v-else-if="assignment.temporaryPhoto" small class="photo-temporary" :aria-label="$t('building.plan.temporaryPhoto')">mdi-clock-outline</v-icon>
    </div>
    <div class="person-data">
      <router-link v-if="interactive && admin && assignment.personId" :to="'/manage/edit/researchers/edit/' + assignment.personId" class="person-name">{{ assignment.name }}</router-link>
      <span v-else class="person-name">{{ assignment.name }}</span>
      <template v-if="admin">
        <div class="person-expiration" :class="'person-expiration--' + assignment.state">
          <v-icon small>{{ assignment.state === 'expired' ? 'mdi-calendar-alert' : 'mdi-calendar-clock' }}</v-icon>
          {{ assignment.expiration ? $t('building.plan.states.' + assignment.state) + ' · ' + formatDate(assignment.expiration) : $t('building.plan.noExpiration') }}
        </div>
        <div v-if="assignment.needsPhoto || assignment.needsBio" class="person-pending">
          <span v-if="assignment.needsPhoto"><i class="pending-dot pending-dot--photo" />{{ $t('building.plan.photoPending') }}</span>
          <span v-if="assignment.needsBio"><i class="pending-dot pending-dot--bio" />{{ $t('building.plan.bioPending') }}</span>
        </div>
      </template>
    </div>
  </article>
</template>

<script>
import { photoUrl } from './planModel';
export default {
  props: { assignment: { type: Object, required: true }, admin: Boolean, endpoint: { type: String, required: true }, interactive: Boolean },
  data: () => ({ photoFailed: false }),
  watch: { 'assignment.photo'() { this.photoFailed = false; } },
  methods: {
    photoUrl,
    formatDate(value) { const date = new Date(value + 'T12:00:00'); const locale = this.$i18n.locale === 'gl' ? 'es-ES' : this.$i18n.locale; return Number.isNaN(date.getTime()) ? value : new Intl.DateTimeFormat(locale).format(date); }
  }
};
</script>

<style scoped>
.detail-person { display: grid; grid-template-columns: 52px minmax(0, 1fr); gap: 12px; padding: 14px 0; border-bottom: 1px solid #e8ebec; }
.person-photo { height: 64px; position: relative; display: flex; align-items: center; justify-content: center; background: #f0f2f2; border-radius: 4px; overflow: hidden; }
.person-thumbnail { display: block; width: 52px; height: 64px; object-fit: cover; }
.person-photo-button { position: relative; width: 52px; height: 64px; padding: 0; border: 0; cursor: zoom-in; }
.person-photo-button:focus-visible { outline: 2px solid #ec651e; outline-offset: -2px; }
.person-photo-button .photo-enlarge { position: absolute; top: 2px; right: 2px; padding: 2px; border-radius: 3px; background: #ffffffed; color: #343b3d; opacity: 0; transition: opacity 120ms; }
.person-photo-button:hover .photo-enlarge, .person-photo-button:focus-visible .photo-enlarge { opacity: 1; }
.person-photo .photo-temporary { position: absolute; bottom: 2px; right: 2px; background: white; color: #8250ff; border-radius: 50%; }
.person-name { display: block; font-size: 14px; font-weight: 600; line-height: 1.4; overflow-wrap: anywhere; }
.person-expiration { margin-top: 5px; font-size: 12px; color: #637076; }
.person-expiration--expired { color: #b82828; }
.person-expiration--expiring { color: #876000; }
.person-expiration .v-icon { color: inherit; }
.person-pending { display: flex; flex-wrap: wrap; gap: 5px 10px; margin-top: 6px; font-size: 11px; color: #637076; }
.person-pending span { display: inline-flex; align-items: center; gap: 4px; }
.pending-dot { display: inline-block; width: 6px; height: 6px; border-radius: 50%; }
.pending-dot--photo { background: #8250ff; }
.pending-dot--bio { background: #50a3ff; }
</style>
